import { Injectable } from '@angular/core';
import { HttpService } from '@app/shared/services/http/http.service';
import { UrlService } from '@app/shared/services/url/url.service';
import {
  ICreateInternalRevaluationRequest,
  IidentificationRequest,
} from '../models/identification-request';

@Injectable()
export class TvfScreeningService {
  constructor(
    private _httpService: HttpService,
    private _urlService: UrlService
  ) {}

  getIdentification(payload: IidentificationRequest) {
    const url = this._urlService.getUrl('RECERTIFICATION_TVF.getIdentification');
    return this._httpService.post(url, payload);
  }

  getDeviceConditionQuestions(
    tradeId: string,
    poweron: boolean | string,
    brand: string = '',
    model: string = '',
    reasonId?: string,
    locked: boolean = false
  ) {
    const url = this._urlService.getUrl('RECERTIFICATION_TVF.getDeviceConditionQuestions');
    return this._httpService.get(url, {
      tradeId, poweron, brand, model, locked,
      ...(reasonId !== undefined ? { reasonId } : {}),
    });
  }

  saveInternalRevaluation(payload: ICreateInternalRevaluationRequest) {
    const url = this._urlService.getUrl('RECERTIFICATION_TVF.saveInternalRevaluation');
    return this._httpService.post(url, payload);
  }

  getEvaluations(idTrade: string) {
    const url = this._urlService.getUrl('RECERTIFICATION_TVF.getevaluations', { idTrade });
    return this._httpService.get(url, {});
  }

  verifyImei(idTrade: string) {
    const url = this._urlService.getUrl('COLLECT_TVF.verifyImei', { idTrade });
    return this._httpService.get(url, {});
  }

  getScreeningResult(idTrade: string) {
    const url = this._urlService.getUrl('RECERTIFICATION_TVF.getScreeningResult', { idTrade });
    return this._httpService.get(url, {});
  }
}
